/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DevisPhoto } from './DevisPhoto';
import {
    DevisPhotoFromJSON,
    DevisPhotoFromJSONTyped,
    DevisPhotoToJSON,
    DevisPhotoToJSONTyped,
} from './DevisPhoto';

/**
 * A validation request of a quote, as shown to the broker.
 * @export
 * @interface DemandeValidationDto
 */
export interface DemandeValidationDto {
    /**
     * 
     * @type {string}
     * @memberof DemandeValidationDto
     */
    id: string;
    /**
     * Status of the request.
     * - EnAttente: sent to the validators, waiting for an answer
     * - Validee: validated as is
     * - ValideeAvecModifications: validated after the validator changed the quote
     * - Refusee: refused, the quote is blocked for good
     * - Invalidee: superseded by a change of the quote by the broker
     * - Annulee: withdrawn by the broker while pending
     * 
     * @type {string}
     * @memberof DemandeValidationDto
     */
    statut: DemandeValidationDtoStatutEnum;
    /**
     * 
     * @type {Date}
     * @memberof DemandeValidationDto
     */
    dateDemande: Date;
    /**
     * Name of the account that sent the request.
     * @type {string}
     * @memberof DemandeValidationDto
     */
    demandeePar?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DemandeValidationDto
     */
    messageCourtier?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof DemandeValidationDto
     */
    dateReponse?: Date | null;
    /**
     * Name of the validator who answered, null while pending.
     * @type {string}
     * @memberof DemandeValidationDto
     */
    traiteePar?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DemandeValidationDto
     */
    messageValideur?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DemandeValidationDto
     */
    clauseParticuliere?: string | null;
    /**
     * 
     * @type {DevisPhoto}
     * @memberof DemandeValidationDto
     */
    devisAvant: DevisPhoto;
    /**
     * Snapshot of the quote after the validator changes, null otherwise.
     * @type {DevisPhoto}
     * @memberof DemandeValidationDto
     */
    devisApres?: DevisPhoto | null;
    /**
     * 
     * @type {number}
     * @memberof DemandeValidationDto
     */
    nombreDestinataires: number;
}


/**
 * @export
 */
export const DemandeValidationDtoStatutEnum = {
    EnAttente: 'EnAttente',
    Validee: 'Validee',
    ValideeAvecModifications: 'ValideeAvecModifications',
    Refusee: 'Refusee',
    Invalidee: 'Invalidee',
    Annulee: 'Annulee'
} as const;
export type DemandeValidationDtoStatutEnum = typeof DemandeValidationDtoStatutEnum[keyof typeof DemandeValidationDtoStatutEnum];


/**
 * Check if a given object implements the DemandeValidationDto interface.
 */
export function instanceOfDemandeValidationDto(value: object): value is DemandeValidationDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('statut' in value) || value['statut'] === undefined) return false;
    if (!('dateDemande' in value) || value['dateDemande'] === undefined) return false;
    if (!('devisAvant' in value) || value['devisAvant'] === undefined) return false;
    if (!('nombreDestinataires' in value) || value['nombreDestinataires'] === undefined) return false;
    return true;
}

export function DemandeValidationDtoFromJSON(json: any): DemandeValidationDto {
    return DemandeValidationDtoFromJSONTyped(json, false);
}

export function DemandeValidationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DemandeValidationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'statut': json['statut'],
        'dateDemande': (new Date(json['dateDemande'])),
        'demandeePar': json['demandeePar'] == null ? undefined : json['demandeePar'],
        'messageCourtier': json['messageCourtier'] == null ? undefined : json['messageCourtier'],
        'dateReponse': json['dateReponse'] == null ? undefined : (new Date(json['dateReponse'])),
        'traiteePar': json['traiteePar'] == null ? undefined : json['traiteePar'],
        'messageValideur': json['messageValideur'] == null ? undefined : json['messageValideur'],
        'clauseParticuliere': json['clauseParticuliere'] == null ? undefined : json['clauseParticuliere'],
        'devisAvant': DevisPhotoFromJSON(json['devisAvant']),
        'devisApres': json['devisApres'] == null ? undefined : DevisPhotoFromJSON(json['devisApres']),
        'nombreDestinataires': json['nombreDestinataires'],
    };
}

export function DemandeValidationDtoToJSON(json: any): DemandeValidationDto {
    return DemandeValidationDtoToJSONTyped(json, false);
}

export function DemandeValidationDtoToJSONTyped(value?: DemandeValidationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'statut': value['statut'],
        'dateDemande': ((value['dateDemande']).toISOString()),
        'demandeePar': value['demandeePar'],
        'messageCourtier': value['messageCourtier'],
        'dateReponse': value['dateReponse'] == null ? undefined : ((value['dateReponse'] as any).toISOString()),
        'traiteePar': value['traiteePar'],
        'messageValideur': value['messageValideur'],
        'clauseParticuliere': value['clauseParticuliere'],
        'devisAvant': DevisPhotoToJSON(value['devisAvant']),
        'devisApres': DevisPhotoToJSON(value['devisApres']),
        'nombreDestinataires': value['nombreDestinataires'],
    };
}

